import request from '../utils/request';

export function getUserRiskLevel (){
    return request({
        url: "/wxmanager/risk/riskLevel",
        method:'post',
    });
}

export function getUserInfo (){
    return request({
        url: "/wxmanager/person/userinfo",
        method:'post',
    });
}

export function getRiskManager (){
    return request({
        url: "/wxmanager/risk/riskManager",
        method:'post',
    });
}

export function getBaseRisk (){
    return request({
        url: "/wxmanager/risk/baseRiskLevel",
        method:'post',
    });
}